import { render, staticRenderFns } from "./UserRoles.vue?vue&type=template&id=0a6b189e&scoped=true&"
import script from "./UserRoles.vue?vue&type=script&lang=ts&"
export * from "./UserRoles.vue?vue&type=script&lang=ts&"
import style0 from "./UserRoles.vue?vue&type=style&index=0&id=0a6b189e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6b189e",
  null
  
)

export default component.exports